const Navbar = () => {
    return (
            <div className="navbar1">
               
        </div>
    );
};

export default Navbar;